import { ReactElement, useMemo, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie as DriverIcon } from '@fortawesome/free-solid-svg-icons';

import { DriverInfoProps } from './types';
import DescriptionWithIconBox from '../DescriptionWithIconBox';

const DriverInfo = ({
  driver,
  fontSize = 16,
  withTooltip = false,
}: DriverInfoProps): ReactElement => {
  const tooltipMessage = useMemo(
    () => (withTooltip ? 'Chofer' : undefined),
    [withTooltip],
  );

  return (
    <DescriptionWithIconBox
      icon={<FontAwesomeIcon icon={DriverIcon} />}
      description={driver}
      size={fontSize}
      iconTooltip={tooltipMessage}
    />
  );
};

export default memo(DriverInfo);
